import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment-timezone';
import LoadQueueHeader from './LoadQueueHeader';
import LoadQueueList from './LoadQueueList';
import {
	getLoadQueueList,
	getUnLoadSiteList, setSelectedLoadIds,
	getLoadQueueCustomerList,
	setLoadQueueInputs
} from '../../../actions/load';
import { getLogisticsLot, getLogisticsSupplier, getLogisticsVariety, getLogisticsSeedType, getLogisticsSeedCuttingGroup } from '../../../actions/logistics';
import LoadQueueBulkEdit from './LoadQueueBulkEdit';
import LoadQueueFilterSection from './LoadQueueFilterSection';
import { getUserConfiguration } from '../../../actions/user';
import { setLoadQueueSearchText, approveLoad } from '../../../actions/load';
import { getGeoStorageLocation } from '../../../actions/geo';
import { isPlannedOrTodate, isToday, usePermission } from '../../../helpers/common';
import { useLoadQueueContext } from './context/LoadQueueContext';
import { API_DATETIME_FORMAT } from '../../../constants';
import { getFarmSettings } from '../../../actions/farm';
import { saveScaleInfo } from "../../../actions/remote-scale";
import { Unit } from '../../../helpers/unit';
import {  getLoadQueueSessionInputs, getUserId } from '../../../helpers/session';

const LoadQueue = props => {
	const unit = Unit.getInstance();
	const dispatch = useDispatch();
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const farmConfig = useSelector(state => state.farm.farmSettings.farm_config);
	const scaleSocket = useSelector(state => state.scaleSocket);
	const {
		loadQueueType,
		loadQueueSearchText,
		loadQueueInput: loadQueueInputs,
		selectedLoadIds,
		unLoadSiteList
	} = useSelector(state => state.load);
	const loadList = useSelector(state => state.load.loadQueueList.data);
	const timezone = useSelector(state => state.farm.currentFarm.timezone_identifier);
	const search = useSelector(state => state.analyze.searchParams);
	const autoRefresh = useSelector(state => state.user.configuration.autoRefresh
		? state.user.configuration.autoRefresh.load_queue : true);
	const roleId = useSelector(state => state.auth.userInfo.role_id);
	const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);

	const { farmId } = props;
	const allow = usePermission();
	const [searchText, setSearchText] = useState(loadQueueSearchText);
	const [isSelectAll, setSelectAll] = useState(false);
	const [loadMoreCount, setLoadMoreCount] = useState(1);
	const { isEdited, setIsEdited, setApproving, editedLoadsById, approving } = useLoadQueueContext();
	const isAllowMap = allow("map", "view");
	const [isApproveDataValid, setApproveDataValid] = useState(true);

	const { range, rangeId, custom } = search;
	let sessionInputs = getLoadQueueSessionInputs();
	let timerId = null;
	// const history = useHistory();
	// useEffect(() => {
	//     return () => props.actions.setLoadHistoryParams({ farmId, crewId, egId });
	// }, [farmId, crewId, egId]);

	const { load_queue: { visible: dropDownVisible,
		configuration: { load_queue_params = [] } = {} } = {}
	} = farmSettings || {};


	const [formDatas, setFormDatas] = useState(null);

	const recentHours = useMemo(() => {
		let updatedHours;
		if (farmConfig) {
			updatedHours = farmConfig && farmConfig.load_queue_recent_hours &&
				farmConfig.load_queue_recent_hours.recent_hours ?
				farmConfig.load_queue_recent_hours.recent_hours : 0;
			return updatedHours;
		}
	}, [farmConfig]);

	const logisticSubHarvest = loadList.filter(it => it.targetPlanTypeId === 4);
	const isLogisticSubHarvest = (planTypeId === 5 && logisticSubHarvest.length > 0);
	useEffect(() => {
		dispatch(setLoadQueueInputs(sessionInputs));
	}, []);
	useEffect(() => {
		if (dropDownVisible && load_queue_params && load_queue_params.length > 0) {
			const tmp_fields = load_queue_params.map((e) => {
				return {
					...e,
					options: (Array.isArray(e.values) && e.values.length > 0)
						? e.values.map((elm) => {
							return { value: elm, label: elm }
						}) : []
				}
			})
			setFormDatas(tmp_fields);
		} else {
			setFormDatas(null);
		}
	}, [dropDownVisible, load_queue_params])

	useEffect(() => {
		dispatch(getUserConfiguration("autoRefresh", { configuration_name: "AutoRefresh" }));
		setSearchText(loadQueueSearchText);
		dispatch(getLoadQueueCustomerList({ farm_uuid: farmId }));
		//if (!window.scaleSocketClient) props.actions.connectScaleSocket();
	}, []);
	useEffect(() => {
		dispatch(getLoadQueueCustomerList({ farm_uuid: farmId }));
	}, [farmId]);
	/* useEffect(() => {
		if (isRemoteScaleEnable) {
			if (!window.scaleSocketClient) dispatch(connectScaleSocket());
		} else {
			if (window.scaleSocketClient) dispatch(disconnectScaleSocket());
		}
	}, [isRemoteScaleEnable]) */

	const { socketConneted, runningWeight, grossOrNet } = useMemo(() => {
		const { isConnected, scaleWeightInfo } = scaleSocket;
		const { weight: scaleWeight, scale_at_standstill, gross_or_net } = scaleWeightInfo;
		return { socketConneted: isConnected, runningWeight: scaleWeight, scaleAtStandStill: scale_at_standstill, grossOrNet: gross_or_net }
	}, [scaleSocket]);

	useEffect(() => {
		dispatch(getUnLoadSiteList(farmId));
		dispatch(getFarmSettings({ farm_uuid: farmId, plan_type_id: planTypeId }));
	}, [farmId]);

	useEffect(() => {
		const list = loadList.slice(0, loadMoreCount * 50);
		if (list.length !== 0 && selectedLoadIds.length === list.length) setSelectAll(true);
		else setSelectAll(false);
	}, [loadList, loadMoreCount, selectedLoadIds]);

	useEffect(() => {
		clearTimer();
		if (loadQueueType === 1 && autoRefresh && selectedLoadIds.length === 0 && !isEdited && isToday(range)) {
			timerId = setInterval(getLoadList, 2 * 60 * 1000);
		}
		return clearTimer;
	}, [farmId, loadQueueType, rangeId, isEdited, selectedLoadIds, autoRefresh]);

	useEffect(() => {
		getLoadList();
		if (planTypeId && planTypeId === 5) {
			dispatch(getLogisticsSupplier(farmId));
			dispatch(getLogisticsLot(farmId));
			dispatch(getLogisticsVariety(farmId));
			dispatch(getLogisticsSeedType(farmId));
			dispatch(getLogisticsSeedCuttingGroup(farmId));
		}
	}, [farmId, loadQueueType, rangeId, planTypeId, recentHours]);

	useEffect(() => {
		if (loadList.length === 0) setLoadMoreCount(1);
	}, [loadList]);

	const handleSelectAll = (selectAll) => {
		if (selectAll) {
			const list = loadList.slice(0, loadMoreCount * 10).map(item => item.loadActivityId);
			dispatch(setSelectedLoadIds(list));
		} else dispatch(setSelectedLoadIds([]));
		setSelectAll(selectAll);
	};

	const handleRefresh = () => {
		getLoadList();
		setIsEdited(false);
		dispatch(setSelectedLoadIds([]));
	};

	const getLoadList = () => {
		let from = null, to = null;
		if (!isPlannedOrTodate(range)) {
			if (custom.from && custom.to) {
				from = isToday(range) ? moment.utc(custom.from).subtract(recentHours, "hours").format(API_DATETIME_FORMAT) :
					moment.utc(custom.from).format(API_DATETIME_FORMAT);
				to = moment.utc(custom.to).format(API_DATETIME_FORMAT);
			} else {
				const now = moment.utc().tz(timezone);
				from = now.clone().startOf("day").format(API_DATETIME_FORMAT);
				to = now.clone().endOf("day").format(API_DATETIME_FORMAT);
			}
		}

		const loadParams = {
			farmId,
			approved: (loadQueueType === 2),
			rangeType: range,
			...!isPlannedOrTodate(range) && { fromDate: from, toDate: to },
			is_current_customer_load: [9].includes(roleId),
			planTypeId
		};
		dispatch(getLoadQueueList(loadParams));
	};

	const clearTimer = () => {
		if (timerId) clearInterval(timerId);
		timerId = null;
	};

	// const getLoadHistory = () => {
	//     props.onHide();
	//     history.push(`/home/farm/${farmId}/loadhistory`);
	// };

	const handleMultiApprove = () => {
		setApproving(true);
		const seletedLoads = loadList.filter(item => selectedLoadIds.indexOf(item.loadActivityId) >= 0);
		const approvalLoads = seletedLoads.map(item => ({ ...item, ...editedLoadsById[item.loadActivityId] }));
		const data = [];

		const { offloadGeoShapeId, offloadStorageLocationId, offloadStoragePipe } = loadQueueInputs;
		const findShape = offloadGeoShapeId ? unLoadSiteList.filter(e => e.geo_shape_uuid === offloadGeoShapeId) : [];

		approvalLoads.forEach(item => {

			const offload_geo_shape_uuid = offloadGeoShapeId ? offloadGeoShapeId : (item && item.offloadGeoShapeId) ? item.offloadGeoShapeId : null;
			const offload_geo_region_name = (findShape.length > 0) ? findShape[0].geo_region_name : (item && item.offloadGeoRegionName) ? item.offloadGeoRegionName : null;
			const offload_geo_region_uuid = (findShape.length > 0) ? findShape[0].geo_region_uuid : (item && item.offloadGeoRegionId) ? item.offloadGeoRegionId : null;
			const offload_geo_shape_name = (findShape.length > 0) ? findShape[0].geo_shape_name : (item && item.offloadGeoShapeName) ? item.offloadGeoShapeName : null;
			const offload_geo_storage_location_uuid = offloadStorageLocationId ? offloadStorageLocationId : (item && item.offloadStorageLocationId) ? item.offloadStorageLocationId : null;;

			const params = {
				farm_uuid: farmId,
				source_equipment_group_uuid: item.sourceEquipmentGroupId,
				target_equipment_group_uuid: item.targetEquipmentGroupId,
				load_activity_uuid: item.loadActivityId,
				load_capacity: item.loadCapacity,
				light_weight: item.lightWeight ? item.lightWeight : null,
				offload_geo_shape_uuid,
				offload_geo_region_name,
				offload_geo_region_uuid,
				offload_geo_shape_name,
				offload_geo_storage_location_uuid,
				tare_weight: item.tareWeight ? Number(item.tareWeight) : null,
				load_gross_weight: item.loadGrossWeight ? Number(item.loadGrossWeight) : null,
				pipe: offloadStoragePipe ? offloadStoragePipe : item.pipe ? item.pipe : null,
				pipeId: offloadStoragePipe ? offloadStoragePipe : item.pipeId ? item.pipeId : null,
				load_params: item.load_params ? item.load_params : null
			};
			data.push(params);
		});

		const isValid = checkValidation(data);
		if (!isValid) {
			setApproving(false);
			return;
		};

		const acknowledgeScale = (data) => {
			if (socketConneted && data.length > 0) {
				data.forEach(elm => {
					const params = {
						...scaleSocket.scaleWeightInfo,
						"equipment_group_uuid": elm.target_equipment_group_uuid,
						"modified_by_uuid": getUserId()
					}
					let isWeightDiff = false;
					const gross = unit.toWeight(elm.load_gross_weight, 2);
					const net = unit.toWeight(elm.load_capacity, 2);
					if (grossOrNet && grossOrNet === 'G' && runningWeight !== gross) {
						params["weight"] = gross;
						isWeightDiff = true;
					} else if (grossOrNet && grossOrNet === 'N' && runningWeight !== net) {
						params["weight"] = net;
						isWeightDiff = true;
					}
					if (isWeightDiff) {
						params["original_data"] = scaleSocket.scaleWeightInfo
					}
					dispatch(saveScaleInfo(params));
				});

			}
		}

		dispatch(approveLoad({ farm_uuid: farmId, loads: data, planTypeId }, (isApproved) => {
			if (isApproved) {
				// update offload default storage location
				const defaultStorageLocations = data.filter(e => e.offload_geo_storage_location_uuid === 'default');
				let geo_region_shape_uuid = defaultStorageLocations.map((item) => {
					const findShape = unLoadSiteList.find(e => e.geo_shape_uuid === item.offload_geo_shape_uuid) || {};
					return findShape.geo_shape_object_uuid;
				}).filter(geoShapeObjectId => Boolean(geoShapeObjectId));
				geo_region_shape_uuid = [...new Set(geo_region_shape_uuid)].join(',');

				geo_region_shape_uuid && dispatch(getGeoStorageLocation({ geo_region_shape_uuid }));

				dispatch(setSelectedLoadIds([]));
				setIsEdited(false);
				const callAck = false;
				if (callAck && socketConneted && data && data.length === 1) { acknowledgeScale(data) };
			}
			setApproving(false);
		}));
	};

	const checkValidation = (data) => {
		let isValid = true;
		if (formDatas && formDatas.length > 0) {
			for (let i = 0; i < formDatas.length; i++) {
				const formData = formDatas[i];
				if (!formData) continue;
				if (formData.required) {
					const filterList = data.filter((el) => (!el.load_params || (el.load_params && !el.load_params[formData.key])));
					if (filterList && filterList.length > 0) {
						isValid = false;
						setApproveDataValid(false);
						break;
					}
				}
				if (formData.hasOwnProperty('rules') && formData.rules.hasOwnProperty('max_length')) {
					const filterList = data.filter((el) =>
					(el.load_params && el.load_params[formData.key] && el.load_params[formData.key].toString().trim().length
						> formData.rules.max_length));
					if (filterList && filterList.length > 0) {
						isValid = false;
						setApproveDataValid(false);
						break;
					}
				}
			}
		}
		return isValid;
	}

	return <div className={`load-queue animate animate__slideInRight ${!isAllowMap && [9].includes(roleId) && 'customer-load-queue'}`}>
		<LoadQueueHeader
			farmId={farmId}
			onHide={props.onHide}
			onRefresh={handleRefresh}
			onSearch={(text) => {
				setSearchText(text);
				dispatch(setLoadQueueSearchText(text));
			}}
			searchText={searchText}
			isEdited={isEdited}
			selectedLoadIds={selectedLoadIds}
		// onLoadHistory={() => {
		//     props.actions.setLoadHistoryParams({ farmId });
		//     props.actions.setLoadHistoryShowModal(true);
		// }}
		/>
		<div className="m-0">
			<LoadQueueFilterSection
				onSearch={(text) => {
					setSearchText(text);
					dispatch(setLoadQueueSearchText(text));
				}}
				searchText={searchText}
				handleMultiApprove={handleMultiApprove}
				isApproving={approving}
				selectedLoadIds={selectedLoadIds}
				isLogisticSubHarvest={isLogisticSubHarvest}
			/>

			{(loadQueueType === 1 && loadList.length > 0) && (
				<Row className='w-100 m-0'>
					<Col className={`col-10 pr-0`}>
						<LoadQueueBulkEdit />
					</Col>
					<Col>
						<div className="select-all-input mt-3">
							<Row className="d-flex m-0">
								<div className="select-all">
									Select all
								</div>
								<div className="checkmark-container">
									<input type="checkbox" checked={isSelectAll} onChange={() => handleSelectAll(!isSelectAll)} />
									<span className={`checkmark`}></span>
								</div>
							</Row>
						</div>
					</Col>
				</Row>)}
		</div>
		<div className={`load-queue-body`}>
			<LoadQueueList
				farmId={farmId}
				searchText={searchText}
				loadMoreCount={loadMoreCount}
				dropDownVisible
				formDatas={formDatas}
				isApproveDataValid={isApproveDataValid}
				setLoadMoreCount={setLoadMoreCount} />
		</div>
	</div>;
};

export default LoadQueue;